import React, { Component } from 'react'
import { Link } from 'react-router-dom'
import { withTranslation } from 'react-i18next';

const GenericError = (props) => {
    return (
        <div>
            <h1 style={{'textAlign': 'center'}}>{props.t('error').toUpperCase()}</h1>
            <hr />
            <h3>{props.t('errorMessage')}</h3> 
            <h4><Link to="/login">{props.t('navigateHome')}</Link> {props.t('nativateHomeCont')}</h4>
        </div>
    )
};

export default withTranslation()(GenericError);
